export default __webpack_public_path__ + "static/right-40d2a4397ac12e8d1700855151b724df.png";